import React from "react";
import invoke from "lodash/invoke";
import { RillContext } from "../../rill/RillReact/share/base";

const Clipboard = process.browser && require("clipboard");

class CopyInput extends React.Component {
  constructor(props, ctx) {
    super(props, ctx);
    this.state = { copied: undefined };
    this.buttonRef = React.createRef();
  }

  componentDidMount() {
    this.clipboard = new Clipboard(this.buttonRef.current, {
      text: () => this.props.text,
    });
    this.clipboard.on("success", () => {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.setState({ copied: undefined });
      }, 500);
      this.setState({ copied: "" });
    });
  }

  componentWillUnmount() {
    invoke(this.clipboard, "destroy");
  }

  render() {
    return React.cloneElement(React.Children.only(this.props.children), {
      "data-copied": this.state.copied,
      ref: this.buttonRef,
    });
  }
}

CopyInput.contextType = RillContext;

export default CopyInput;
